import type { EventName } from '@obs-schema';
import { allowedProps } from '@obs-schema';
import { initMixpanel as _init, identify as _identify, alias as _alias, track as _track } from '@/analytics/mixpanel';
import { hasAnalyticsConsent } from './consent';

let analyticsInitialized = false;

export function initAnalytics() {
  if (analyticsInitialized) return;
  if (!hasAnalyticsConsent()) return;
  try {
    _init();
    analyticsInitialized = true;
  } catch {}
}

export function track(eventName: string, props?: Record<string, unknown>): void {
  if (!hasAnalyticsConsent()) return;
  try {
    // Gate unknown events
    const ok = (() => { try { return allowedProps(eventName as any) instanceof Set; } catch { return false; } })();
    if (!ok) return;
    _track(eventName as EventName, (props || {}) as any);
  } catch {}
}

export function identify(userId?: string, traits?: Record<string, unknown>): void {
  if (!hasAnalyticsConsent()) return;
  try { _identify(userId, traits); } catch {}
}

export function alias(userId: string): void {
  if (!hasAnalyticsConsent()) return;
  try { _alias(userId); } catch {}
}

export function registerSuper(_props: Record<string, unknown>): void {
  // Deprecated: no-op to avoid free-form super properties
}

